(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/format-date.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/format-date.js');
"use strict";


const _dateFns = dateFns,
  format = _dateFns.format,
  isToday = _dateFns.isToday,
  isTomorrow = _dateFns.isTomorrow,
  isYesterday = _dateFns.isYesterday,
  isWithinInterval = _dateFns.isWithinInterval,
  addDays = _dateFns.addDays;
const sv = dateFns.locales.sv;
const formatDate = (dateString, _ref) => {
  let _ref$showDayOfWeek = _ref.showDayOfWeek,
    showDayOfWeek = _ref$showDayOfWeek === void 0 ? false : _ref$showDayOfWeek,
    _ref$showNearDaysAsLa = _ref.showNearDaysAsLabel,
    showNearDaysAsLabel = _ref$showNearDaysAsLa === void 0 ? false : _ref$showNearDaysAsLa,
    _ref$showLongDate = _ref.showLongDate,
    showLongDate = _ref$showLongDate === void 0 ? false : _ref$showLongDate;
  const date = new Date(dateString);
  const now = new Date();
  if (showNearDaysAsLabel) {
    if (isToday(date)) {
      return "idag ".concat(format(date, 'HH:mm'));
    }
    if (isTomorrow(date)) {
      return "imorgon ".concat(format(date, 'HH:mm'));
    }
    if (isYesterday(date)) {
      return "ig\xE5r ".concat(format(date, 'HH:mm'));
    }
    if (isWithinInterval(date, {
      start: addDays(now, 2),
      end: addDays(now, 6)
    })) {
      return showLongDate ? "".concat(format(date, 'EEEE HH:mm', {
        locale: sv
      })) : "".concat(format(date, 'EEE HH:mm', {
        locale: sv
      }));
    }
  }
  if (showDayOfWeek) {
    return showLongDate ? "".concat(format(date, 'EEEE d/M HH:mm', {
      locale: sv
    })) : "".concat(format(date, 'EEE d/M HH:mm', {
      locale: sv
    }));
  }
  return format(date, 'd/M HH:mm');
};
setGlobal('svs.components.poolBetting.utils.formatDate', formatDate);

 })(window);